import { render, staticRenderFns } from "./AdditionalServicesWarningDialog.vue?vue&type=template&id=175a2fe8&scoped=true&lang=pug&"
import script from "./AdditionalServicesWarningDialog.vue?vue&type=script&lang=ts&"
export * from "./AdditionalServicesWarningDialog.vue?vue&type=script&lang=ts&"
import style0 from "./AdditionalServicesWarningDialog.vue?vue&type=style&index=0&id=175a2fe8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "175a2fe8",
  null
  
)

export default component.exports